var ComponentScrollTitleComponent = (function () {
    function ComponentScrollTitleComponent() {
    }
    ComponentScrollTitleComponent.prototype.ngOnInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.isShow = true;
        }, 500);
        setTimeout(function () {
            _this.isShow = false;
        }, 2500);
    };
    return ComponentScrollTitleComponent;
}());
export { ComponentScrollTitleComponent };



// WEBPACK FOOTER //
// ./src/app/scroll-title/component.scroll-title.ts.pre-build-optimizer.js